import { render } from "./RobotTaskListView.vue?vue&type=template&id=5d970d26&scoped=true"
import script from "./RobotTaskListView.vue?vue&type=script&lang=js"
export * from "./RobotTaskListView.vue?vue&type=script&lang=js"

import "./RobotTaskListView.vue?vue&type=style&index=0&id=5d970d26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d970d26"]])

export default __exports__